export var STYLOVYZE_FLAGS;
(function (STYLOVYZE_FLAGS) {
    STYLOVYZE_FLAGS["TEST"] = "info-360-test";
    STYLOVYZE_FLAGS["ANALYTICS_REFERENCE_CHARTS"] = "info-360-analytics-reference-charts";
    STYLOVYZE_FLAGS["ADMIN_BILLING"] = "info-360-admin-billing";
    STYLOVYZE_FLAGS["INSIGHT_ABOUT_BOX"] = "info360-insight-about-box";
    STYLOVYZE_FLAGS["ASSET_ABOUT_BOX"] = "info360-asset-about-box";
    STYLOVYZE_FLAGS["LOCALE"] = "info-360-locale";
    STYLOVYZE_FLAGS["WATER_DISTRIBUTION_ASSET_UPLOAD"] = "info-360-water-distribution-asset";
    STYLOVYZE_FLAGS["WATER_DISTRIBUTION_ASSET_SYSTEM_TYPE_SELECT"] = "info-360-water-distribution-asset-system-type-select";
    STYLOVYZE_FLAGS["REHAB_MULTIPLE_RISK_MODELS"] = "info-360-asset-multiple-risk-models-rehab";
    STYLOVYZE_FLAGS["ABOUT_TO_EXPIRE"] = "info-360-about-to-expire";
    STYLOVYZE_FLAGS["DEBUG_MODE"] = "info-360-debug-messages";
    STYLOVYZE_FLAGS["REHAB_CUSTOM_TABLES_RECORD_TYPE"] = "info-360-rehab-custom-tables-record-type";
    STYLOVYZE_FLAGS["AM_MAP"] = "info-360-am-map";
    STYLOVYZE_FLAGS["AM_INSPECTIONS"] = "info-360-am-inspections";
    STYLOVYZE_FLAGS["AM_RISK"] = "info-360-am-risk";
    STYLOVYZE_FLAGS["AM_GIS_IMPORT"] = "info-360-am-gis-import";
    STYLOVYZE_FLAGS["AM_REHAB"] = "info-360-asset-rehab";
    STYLOVYZE_FLAGS["AM_ADMIN"] = "info-360-am-admin";
    STYLOVYZE_FLAGS["ANALYTIC_HISTORIC_FORECAST"] = "info-360-analytic-historic-forecast";
    STYLOVYZE_FLAGS["ADVANCED_SUPPORT"] = "info-360-advanced-support-features";
    STYLOVYZE_FLAGS["USER_READONLY_ADMIN"] = "info-360-admin-read-only-for-users";
    STYLOVYZE_FLAGS["ARCGIS_BASEMAPS"] = "info-360-arcgis-basemaps";
    STYLOVYZE_FLAGS["SESSION_SHARED_WORKERS"] = "info-360-session-sharedworkers";
    STYLOVYZE_FLAGS["ADSK_ADP_ANALYTICS"] = "info-360-adp-analytics";
    STYLOVYZE_FLAGS["ADSK_ADP_ANALYTICS_DEBUGGING"] = "info-360-adp-analytics-debugging";
})(STYLOVYZE_FLAGS || (STYLOVYZE_FLAGS = {}));
